import { MainAppService } from "src/modules/app-template/services/main-app.service";

export enum CalendarEventReminderType {
    //netgen start
    none = 0,
    mail = 1,
    popup = 2,
    both = 3
    //netgen end
}
export namespace CalendarEventReminderType{
    export function getName(value: CalendarEventReminderType): string {
        switch (value) {
            case CalendarEventReminderType.none:
                return "none";
            case CalendarEventReminderType.mail:
                return "mail";
            case CalendarEventReminderType.popup:
                return "popup";
            case CalendarEventReminderType.both:
                return "both";
            default:
                return "???";
        }
    }

    export function getDisplayName(value: CalendarEventReminderType, app: MainAppService): string {
        return app.t("entity.CalendarEventReminderType." + getName(value));
    }
}
